// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ibXR","fileBtn":"File_fileBtn__1nicZ","closeBtn":"File_closeBtn__2gBHR","fileSelected":"File_fileSelected__3qZIV","disabled":"File_disabled__3-zsr"};